import {
  type GenericMappingByKey,
  GenericMappingType,
} from '../../search/types'
import { getGenericMappingArrayFromGenericMappingByKey } from './utils'

export const GITHUB_GENERIC_MAPPINGS_BY_KEY = Object.freeze({
  number: {
    type: GenericMappingType.KEYWORD,
    name: 'Identifier',
    description: 'Human readable PR/issue identifier',
    order: 0,
  },
  owner: {
    type: GenericMappingType.KEYWORD,
    name: 'Owner',
    description: 'Owner of the github repository the PR/issue belongs to',
    enumFromCollapseEsQuery: true,
    order: 1,
  },
  repo: {
    type: GenericMappingType.KEYWORD,
    name: 'Repository',
    description: 'Name of the github repository the PR/issue belongs to',
    enumFromCollapseEsQuery: true,
    order: 2,
  },
  state: {
    type: GenericMappingType.KEYWORD,
    name: 'State',
    description: 'State of the PR/issue',
    enumFromCollapseEsQuery: true,
    order: 3,
  },
  locked: {
    type: GenericMappingType.BOOLEAN,
    name: 'Locked',
    description: 'True if the PR/Issue is locked',
    order: 4,
  },
  closedAt: {
    type: GenericMappingType.DATE,
    name: 'Closed date',
    description: 'Date when the PR/issue was closed (not the same as merged)',
    order: 5,
  },
  mergedAt: {
    type: GenericMappingType.DATE,
    name: 'Merged date',
    description: 'Date when the PR/issue was merged (not the same as closed)',
    order: 6,
  },
  assignees: {
    type: GenericMappingType.KEYWORD,
    name: 'Assignees',
    description: 'Assignees responsible of the PR/issue',
    enumFromTermsAggEsQuery: true,
    order: 7,
  },
  reviewers: {
    type: GenericMappingType.KEYWORD,
    name: 'Reviewers',
    description: 'Reviewers on the PR/issue',
    enumFromTermsAggEsQuery: true,
    order: 8,
  },
  labels: {
    type: GenericMappingType.KEYWORD,
    name: 'Labels',
    description: 'Labels set on the PR/issue',
    enumFromTermsAggEsQuery: true,
    order: 9,
  },
  milestone: {
    type: GenericMappingType.KEYWORD,
    name: 'Milestone',
    description: 'The milestone PR/issue is associated with',
    enumFromCollapseEsQuery: true,
    order: 10,
  },
  draft: {
    type: GenericMappingType.BOOLEAN,
    name: 'In draft',
    description: 'True if the PR/issue is still in draft',
    order: 11,
  },
  mergedBy: {
    type: GenericMappingType.KEYWORD,
    name: 'Merged by',
    description: 'The user who merged the PR',
    order: 12,
  },
  type: {
    type: GenericMappingType.KEYWORD,
    name: 'Type',
    description: 'pull_request or issue',
    enum: ['issue', 'pull_request'],
    order: 13,
  },
} satisfies GenericMappingByKey)

export const GITHUB_GENERIC_MAPPINGS =
  getGenericMappingArrayFromGenericMappingByKey(GITHUB_GENERIC_MAPPINGS_BY_KEY)
